import { getAllActiveLandingPages } from "@/services/landing.services";
import { createSlice } from "@reduxjs/toolkit";

export interface ILandingPage {
  ID: number | null;
  Title: string;
  URL: string;
  ShortDescription: string;
  LongDescription: string;
  Tagline: string;
  PackageHighlights: string;
  Inclusion: string;
  Exclusion: string;
  MainImage: string;
  BannerImage: string;
  ImageGallery: any[];
  MetaTitle: string;
  MetaKeywords: string;
  MetaDescription: string;
  RomanticSettings: string;
  GuestCapacity: string;
  CustomPackages: string;
}

export interface ILandingPageInitialState {
  loading: boolean;
  error: string;
  LandingPageList: ILandingPage[];
  isLandingPage: boolean;
}

const initialState: ILandingPageInitialState = {
  loading: false,
  error: "",
  LandingPageList: [],
  isLandingPage: false,
};

const LandingPageSlice = createSlice({
  name: "landingPage",
  initialState,
  reducers: {
    setIsLandingPage: (state, action) => {
      state.isLandingPage = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActiveLandingPages.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllActiveLandingPages.fulfilled, (state, action) => {
      state.loading = false;
      state.LandingPageList = action.payload || [];
      state.error = "";
    });
    builder.addCase(getAllActiveLandingPages.rejected, (state, action) => {
      state.loading = false;
      state.LandingPageList = initialState.LandingPageList;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { setIsLandingPage } = LandingPageSlice.actions;

export default LandingPageSlice.reducer;
